import { TableCell, TableRow } from "@mui/material";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { CopyIcon } from "../../../../../../shared/icons/CopyIcon";
import styles from "./styles.module.css";

interface Props {
  token: string;
  onCreate: () => void;
}

export const TokenPreview = (props: Props) => {
  return (
    <TableRow className={styles["table-body-row"]}>
      <TableCell colSpan={2}>
        <div className={styles.container}>
          <div>{props.token}</div>
          <AppIconButton
            children={<CopyIcon />}
            onClick={() => navigator.clipboard.writeText(props.token)}
          />
        </div>
      </TableCell>
      <TableCell>
        <AppButton buttonType={"text"} onClick={props.onCreate}>
          Подтвердить
        </AppButton>
      </TableCell>
    </TableRow>
  );
};
